import axios from "axios";

const rawBackendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";

export const BACKEND_URL = rawBackendUrl.replace(/\/+$/, "").replace(/\/api$/, "");
export const API = `${BACKEND_URL}/api`;
export const SHOW_DEV_OTP =
  process.env.NODE_ENV !== "production" &&
  process.env.REACT_APP_ENABLE_DEV_OTP === "1";

export const submitLead = (payload) => {
  let draftId;
  try { draftId = window.localStorage.getItem("appfillip_active_lead_draft"); } catch { /* Storage may be disabled. */ }
  return axios.post(`${API}/leads`, { ...payload, ...(draftId ? { draft_id: draftId } : {}) });
};
export const subscribeNewsletter = (payload) =>
  axios.post(`${API}/newsletter`, payload);
